export default {
  推荐66人: `推薦66人<br class="mobile" /> 邀您直達巴塞`,
  成为EBC推荐官: "成為EBC推薦官，享受VIP榮耀之旅",
  立即参与: "立即參與",
  活动规则与要求: "活動規則與要求",
  每一次推荐: "每一次推薦，都是叩開巴塞大門的黃金助攻",
  参与规则: "參與規則：",
  成为EBC推荐官并邀请66人: "成為EBC推薦官並邀請66人； ",
  所有被邀请人均入金大于等于$500: `所有被邀請人均入金大於等於$500，<br class="mobile" />且完成交易。`,
  参与方法: "參與方法",
  立即推荐: "立即推薦，以好友的助力，向傳奇致敬。",
  登录EBC用户中心: "登錄EBC用戶中心",
  "进入“大赛推荐官”活动页面": "進入“大賽推薦官”活動頁面",
  生成您的邀请链接或二维码: "生成您的邀請鏈接或二維碼",
  巴萨荣耀之旅: "巴塞榮耀之旅",
  每笔订单都是攻守博弈的艺术: ` 每筆訂單都是攻守博弈的藝術，<br class="mobile" />每個決策都將締造資本市場的史詩級射門。`,
  活动时间: "活動時間：",
  "2025年2月22日": "2025年2月22日 01:00:00(MT4/MT5時間)-2025年8月(MT4/MT5時間)",
  活动规则: "活動規則：",
  ruleList: [
    "該活動與正常推薦獎勵和其他活動不存在衝突。",
    "被推薦人需完成入金並交易，第三方轉帳無效。",
    "推薦獎勵適用於合規交易者，EBC有權對違規行爲取消獎勵資格。",
    "通過邀請活動註冊的帳戶不允許轉移代理。",
    "獲獎以帳號有效激活為準，VIP觀賽席位含機票和住宿。",
    "本活動最終解釋權歸EBC金融集團所有。",
  ],
};
